export const CreateReportRequestRoute = (): string => `/obljobreport`;
export const GetJobStatsRoute = (): string => `/obljobstats`;

export default {
  CreateReportRequestRoute,
  GetJobStatsRoute,
};
